import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  visuallyHiddenStyles,
} from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { md },
}: { BreakpointNames: { xs: string; sm: string; md: string } } =
  constants.breakpoints;

export const searchFormContainerCss = (
  isTabletOrMobileView: boolean,
): CSSObject =>
  isTabletOrMobileView
    ? {
        marginTop: "8px",
        zIndex: 99,
      }
    : {
        position: "sticky",
        top: "8px",
        right: "8px",
        zIndex: 99,

        [mq.upTo(md)]: {
          right: "unset",
          left: 0,
          top: "8px",
        },
      };

export const searchContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center",
  height: "100%",
  "& input": { width: "272px", height: "36px" },
};

export const searchLabelCss: CSSObject = {
  "& > div:first-of-type": visuallyHiddenStyles,
};
